function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Descriptions, Skeleton, message, notification } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import Common from "../components/includes/Common";
import 'bootstrap/dist/css/bootstrap.min.css';
import UpdateCustomer from "../components/forms/UpdateCustomer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SearchCandidat = function SearchCandidat() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customer = _useState4[0],
    setCustomer = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dataUpdated = _useState8[0],
    setDataUpdated = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSearchDataLoading = _useState10[0],
    setIsSearchDataLoading = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    createdValues = _useState12[0],
    setCreatedValues = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    pmOptions = _useState14[0],
    setPmOptions = _useState14[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var ref = useRef();
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _Form$useForm3 = Form.useForm(),
    _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
    sform = _Form$useForm4[0];
  var onFinish = function onFinish(values) {
    setIsSearchDataLoading(true);
    setCustomer(null);
    sform.resetFields();
    axios.get(Common.baseApiUrl + 'getcustomerbyrnc/' + values.rnc).then(function (response) {
      setIsSearchDataLoading(false);
      if (response.data.status == 200) {
        if (response.data.customer == null) notification.error({
          message: "Erreur",
          description: "Aucun candidat ne correspond à votre recherche"
        });
        setCustomer(response.data.customer);
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsSearchDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataUpdated(false);
    setIsSearchDataLoading(false);
    axios.get(Common.baseApiUrl + 'getvalidationqueue/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataUpdated]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getactivepaymenttypes/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.paymentTypes.forEach(function (p) {
          setPmOptions(function (old) {
            return [].concat(_toConsumableArray(old), [{
              label: p.label,
              value: p.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue, contactez l'administrateur",
        delay: 4
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      id: "reprintid",
      children: customer != null && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: '70px'
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/mvc.jpeg",
            style: {
              width: '100%'
            }
          })
        }), /*#__PURE__*/_jsxs("h2", {
          children: ["RNC : ", customer.rnc]
        }), /*#__PURE__*/_jsxs(Descriptions, {
          column: 1,
          children: [/*#__PURE__*/_jsx(Descriptions.Item, {
            label: "T\xE9l\xE9phone : ",
            children: customer.mobile
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Nom :",
            children: customer.firstname + ' ' + customer.lastname
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Montant : ",
            children: "200 000 GNF"
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "M. Paiement : ",
            children: customer.paymentmethod
          })]
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse: Conakry, Kip\xE9, Prima center. Tel: 611 72 49 21"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 2,
          md: 3,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsxs(Form, {
              form: sform,
              onFinish: onFinish,
              layout: "vertical",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "rnc",
                label: "Entrer le RNC",
                rules: [{
                  required: true,
                  message: 'Veuillez entrer le RNC'
                }],
                children: /*#__PURE__*/_jsx(Input, {})
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  loading: isSearchDataLoading,
                  size: "large",
                  htmlType: "submit",
                  type: "primary",
                  children: "Chercher"
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            children: customer && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(UpdateCustomer, {
                customer: customer
              })
            })
          })
        })]
      })
    })]
  });
};
export default SearchCandidat;